import { Col, Container, Row } from 'react-bootstrap';
import MemberIndividualTournamentHistoryContainer from './member-individual-tournament-history-container';
import MemberIndividualNonTournamentHistoryContainer from './member-individual-nontournament-history-container';
import MemberTeamHistoryContainer from './member-team-history-container';
import MemberTeamFormatSummaryContainer from './member-team-format-summary-container';
import type { Member } from '../types/api.types';
import { formatMemberName } from '../utils/members';

interface MemberRecordsProps {
  member: Member | null | undefined;
}

export default function MemberRecords({ member }: MemberRecordsProps) {
  if (member === undefined || member === null) {
    return <h1>Unknown Member ID</h1>;
  }

  const colStyle = {
    padding: 0,
  };

  const rowStyle = {
    display: 'Block' as const,
  };

  return (
    <div>
      <Container>
        <img src={`/assets/${member.id}.jpg`} alt="" style={{ float: 'right' }} />
        <h2>{formatMemberName(member)}</h2>
        <Row style={rowStyle}>
          <Col md={8} style={colStyle}>
            <h4>Tournament Record</h4>
            <MemberIndividualTournamentHistoryContainer member_id={member.id} />
            <h4>Other Comps</h4>
            <MemberIndividualNonTournamentHistoryContainer member_id={member.id} />
            <h4>Ryd-Her Cup Record</h4>
            <MemberTeamHistoryContainer member_id={member.id} />
            <h4>Ryd-Her Cup Match Record</h4>
            <MemberTeamFormatSummaryContainer member_id={member.id} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
